import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetFormularioPECATAByID from "services/record/FormularioPECATA/useGetFormularioPECATAByID";
import useGetInfoFormularioPECATA from "services/record/FormularioPECATA/useGetInfoFormularioPECATA";
import useGetFormularioPECATAByUser from "services/record/FormularioPECATA/useGetFormularioPECATAByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import FormularioPECATA from "./FormularioPECATA";

const GridFormularioPECATA = ({ expedienteId = null, origen = null }) => {

    const {
        getFormularioPECATAByID,
        loadingGetFormularioPECATAByID,
        statusGetFormularioPECATAByID
    } = useGetFormularioPECATAByID();

    const {
        getInfoFormularioPECATA,
        loadingGetInfoFormularioPECATA,
        statusGetInfoFormularioPECATA
    } = useGetInfoFormularioPECATA();

    const {
        dataGetFormularioPECATAByUser,
        getFormularioPECATAByUser,
        loadingGetFormularioPECATAByUser,
        statusGetFormularioPECATAByUser
    } = useGetFormularioPECATAByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Prestación económica por cese de actividad en autónomos";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getFormularioPECATAByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetFormularioPECATAByID?.status) {
            setCurrentHttp({
                status: statusGetFormularioPECATAByID.status,
                statusText: statusGetFormularioPECATAByID.statusText
            });
        } else if (statusGetInfoFormularioPECATA?.status) {
            setCurrentHttp({
                status: statusGetInfoFormularioPECATA.status,
                statusText: statusGetInfoFormularioPECATA.statusText
            });
        } else if (statusGetFormularioPECATAByUser?.status) {
            setCurrentHttp({
                status: statusGetFormularioPECATAByUser.status,
                statusText: statusGetFormularioPECATAByUser.statusText
            });
        }
    }, [
        statusGetFormularioPECATAByID,
        statusGetInfoFormularioPECATA,
        statusGetFormularioPECATAByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getFormularioPECATAByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoFormularioPECATA(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetFormularioPECATAByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 1 || item.EstadoFormulario === 3);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetFormularioPECATAByUser]);

    const isLoading = () => {
        return (
            loadingGetFormularioPECATAByID ||
            loadingGetInfoFormularioPECATA ||
            (loadingGetFormularioPECATAByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetFormularioPECATAByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <FormularioPECATA
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getFormularioPECATAByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && currentHttp.status !== 200 && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridFormularioPECATA;

